import { create } from 'zustand';

import { ApplicationFlagsStoreType } from './types';

export const useApplicationFlags = create<ApplicationFlagsStoreType>((set, _get) => ({
  minimum_app_version: '',
  show_coming_soon_apps: false,
  elevate_ai_enabled: false,
  marketplace_v2_flag: false,
  manager_v2_app_release: true,
  mobile_pay_tab_feature: false,
  enable_terminal_presence_wake_check: true,
  notifications_feat_enabled: false,
  setMobilePayTabFeatureEnabled: (mobile_pay_tab_feature) =>
    set({ mobile_pay_tab_feature }),
  setNotificationsFeatureEnabled: (notifications_feat_enabled) =>
    set({ notifications_feat_enabled }),
  setAllFlags: ({
    minimum_app_version,
    show_coming_soon_apps,
    elevate_ai_enabled,
    marketplace_v2_flag,
    manager_v2_app_release,
    mobile_pay_tab_feature,
    enable_terminal_presence_wake_check,
  }) => {
    set({
      minimum_app_version,
      show_coming_soon_apps,
      elevate_ai_enabled,
      marketplace_v2_flag,
      manager_v2_app_release,
      mobile_pay_tab_feature,
      enable_terminal_presence_wake_check,
    });
  },
}));
